import { Typography } from '@eventbrite/design-ops-ds';
import React from 'react';
import './TopDestinationCard.scss';

type TopDestinationCardProps = {
    displayName: string;
    imageUrl: string;
    locationSlug: string;
};

export const TopDestinationCard = (props: TopDestinationCardProps) => {
    const { displayName, imageUrl, locationSlug } = props;

    return (
        <div
            className="top-destination-card"
            style={{ backgroundImage: `url(${imageUrl})` }}
        >
            <div className="top-destination-card__overlay">
                <Typography
                    color="neutral-100"
                    variant="heading-md"
                    align="left"
                >
                    <a href={`/d/${locationSlug}/events/`} color="neutral-100">
                        {displayName}
                    </a>
                </Typography>
            </div>
            <div className="top-destination-card__gradiant" />
            <div className="top-destination-card__orange-bar eds-bg-color--ui-orange"></div>
        </div>
    );
};
